import { render } from "./CardModeloDocumentos.vue?vue&type=template&id=16c5577b"
import script from "./CardModeloDocumentos.vue?vue&type=script&lang=js"
export * from "./CardModeloDocumentos.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rhylton/Sites/intranet/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__